import { ZERO_ADDRESS } from '../helper';
import IdentityClaimHistory from './IdentityClaimHistory';
import IdentityRewardsForm from './IdentityRewardsForm';
import type { Identity } from '../types';
import { useEvmWallet } from '../hooks/useEvmWallet';

type Props = {
  identityData: Identity;
};

export default function IdentityRewardsTabContent({ identityData }: Props) {
  const { address } = useEvmWallet();
  const isOwner =
    identityData?.nft.owner.toLowerCase() === address?.toLowerCase();

  return (
    <div className="space-y-6">
      <IdentityRewardsForm
        identity={identityData.identityRaw}
        isOwner={isOwner}
        isClaimed={identityData.nft.owner !== ZERO_ADDRESS}
        stakedTokens={identityData.stakedTokens}
        delegatedTokens={identityData.delegatedTokens}
      />
      <div className="h-px bg-divider" />
      <IdentityClaimHistory identity={identityData.identityRaw} />
    </div>
  );
}
